(function () {
  var selector = '[data-collection-description]';

  function initCollectionDescriptions(root) {
    root.querySelectorAll(selector).forEach(function (wrap) {
      if (wrap.dataset.descriptionInit === 'true') return;
      wrap.dataset.descriptionInit = 'true';

      var content = wrap.querySelector('[data-collection-description-content]');
      var toggle = wrap.querySelector('[data-collection-description-toggle]');
      var clampWrap = wrap.querySelector('.collection-description__clamp-wrap');
      if (!content || !toggle || !clampWrap) return;

      var labelMore = toggle.querySelector('[data-label-more]');
      var labelLess = toggle.querySelector('[data-label-less]');

      function setCollapsed(collapsed) {
        content.classList.toggle('is-clamped', collapsed);
        content.classList.toggle('is-expanded', !collapsed);
        clampWrap.classList.toggle('is-expanded', !collapsed);
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (labelMore) labelMore.classList.toggle('hidden', !collapsed);
        if (labelLess) labelLess.classList.toggle('hidden', collapsed);
      }

      function updateToggleVisibility() {
        setCollapsed(true);
        var overflows = content.scrollHeight > content.clientHeight + 1;
        toggle.classList.toggle('hidden', !overflows);
        toggle.hidden = !overflows;
        if (!overflows) {
          content.classList.remove('is-clamped', 'is-expanded');
          clampWrap.classList.remove('is-expanded');
        }
      }

      toggle.addEventListener('click', function () {
        setCollapsed(!content.classList.contains('is-clamped'));
      });

      updateToggleVisibility();
      requestAnimationFrame(updateToggleVisibility);
      window.addEventListener('resize', updateToggleVisibility);
      window.addEventListener('load', updateToggleVisibility);
    });
  }

  function onReady() {
    initCollectionDescriptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionDescriptions(event.target);
  });
})();
